import React, { Component } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import Slider from 'react-slick'

export default class PopupInfoImages extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {}

  render() {
    var props = this.props

    var sliderSettings = {
      dots: false,
      infinite: false,
      centerMode: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: '20px',
    }

    return (
      <div className={styles.lightWrapper}>
        <div className="wrapper">
          {typeof window !== `undefined` && window.innerWidth > 450 && (
            <div className={[styles.container, styles.grid].join(' ')}>
              {props.components.map((image, idx) => (
                <div key={idx} className={styles.cell}>
                  <GatsbyImage
                    image={image.gatsbyImageData}
                    className={styles.image}
                    imgStyle={{ objectFit: 'cover' }}
                    alt={image?.image?.description}
                  />
                  <div className={styles.infoContainer}>
                    <div
                      className={styles.tag}
                      style={{ backgroundColor: props.subtitle.subtitle }}
                    >
                      {image.title}
                    </div>
                    <div className={styles.description}>
                      {image.subtitle.subtitle}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {typeof window !== `undefined` && window.innerWidth <= 450 && (
            <Slider
              {...sliderSettings}
              className={[styles.container, styles.slider].join(' ')}
            >
              {props.components.map((image, idx) => (
                <div key={idx} className={styles.cellContainer}>
                  <div className={styles.cell}>
                    <GatsbyImage
                      image={image.gatsbyImageData}
                      className={styles.image}
                      imgStyle={{ objectFit: 'cover' }}
                      alt={image?.image?.description}
                    />
                    <div className={styles.infoContainer}>
                      <div
                        className={styles.tag}
                        style={{ backgroundColor: props.subtitle.subtitle }}
                      >
                        {image.title}
                      </div>
                      <div className={styles.description}>
                        {image.subtitle.subtitle}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>
    )
  }
}
